import React, { useState } from "react";
import { Pane, Dialog, Button } from "evergreen-ui";
import Component from "@reactions/component";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import axios from "../../assets/js/AxiosInterceptors";
import { toast } from "react-toastify";
import AttachmentIcon from "@mui/icons-material/Attachment";
import SendIcon from "@mui/icons-material/Send";
import "react-datepicker/dist/react-datepicker.css";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "lottie-react-web";
 
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
// import InputFiles from 'react-input-files';
import moment from "moment";
import { IconButton } from "@mui/material";

// import moment from 'moment';
const cookies = new Cookies();

const ShowFilev2 = (props) => {
  const [spin, setSping] = useState(false);

  const deleteFunction = (id) => {
    var headers = {
      "Content-Type": "application/json",
      jwt: cookies.get("token"),
    };
    axios({
      url: Host + `tasks/task_file/${id}`,
      method: "DELETE",
      headers: headers,
      data:{
        is_task_attached:1,
      }
    })
      .then((response) => {
        if (response.data.status === false) {
          if(response?.data?.data?.message){
            toast.error(response?.data?.data?.message);
          }else {
            toast.error(response.data.data.text);
          }
        } else if (response.data.status === true) {
          toast.success("deleted successfully");
          const { onRefTask } = props?.onRefTask;
          onRefTask();
        }
      })
      .catch((err) => {
        toast.error("Network Error");
      });
  };

  return (
    <Dialog
      isShown={props?.showFiles}
      hasHeader={false}
      onCloseComplete={() => props?.setShowFiles(false)}
      hasFooter={false}
      topOffset={150}
    >
      {props?.files?.map((f, i) => (
        <div
          key={i}
          style={{
            color: "#61adc3",
            fontSize: 16,
            fontWeight: "600",
            padding: 10,
            // borderBottom: "1px solid gray",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor:'#f3f3f3',
            borderRadius:5,
            gap:5,
            marginBottom:5
          }}
        >
          <div
            style={{
              width:props?.status=='NEW'?'85%':'100%'
            }}
            onClick={() => {
              window.open(Host + f.file_path);
            }}
          >
            {i + 1} File{" "}
            <span>
              {" "}
              <AttachmentIcon />{" "}
              <span style={{ fontSize: 12 }}>{f.file_path} </span>{" "}
            </span>{" "}
          </div>
         {props?.status=='new'?<div>
            <IconButton
             onClick={()=>{
              if (window.confirm("Delete the File?")) {
                  deleteFunction(f.file_id);
                }
             }}
            >
              <DeleteIcon sx={{color:'#ff0000'}}/>
            </IconButton>
          </div>:null}
        </div>
      ))}

    </Dialog>
  );
};
export default ShowFilev2;
